import type { FC } from 'react';
import { Input } from '@ui';

interface UserDataInputsProps {
  fio: string;
  phone: string;
  onFioChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
}

export const FioInput: FC<{ value: string; onChange: (v: string) => void }> = ({
  value,
  onChange
}) => (
  <Input
    classNameParent='order-page-input'
    classNameInput='custom-input'
    placeHolder='Имя'
    value={value}
    field='fio'
    onInputBlur={next => {
      onChange(next);
    }}
    inputType='text'
    autocomplete='first-name'
  />
);

export const PhoneInput: FC<{
  value: string;
  onChange: (v: string) => void;
}> = ({ value, onChange }) => (
  <Input
    classNameParent='order-page-input'
    classNameInput='custom-input'
    placeHolder='Телефон'
    value={value}
    field='phone'
    onInputBlur={next => {
      onChange(next);
    }}
    inputType='text'
    skipPhoneValidationOnChange
    autocomplete='phone'
  />
);

const UserDataInputs: FC<UserDataInputsProps> = ({
  fio,
  phone,
  onFioChange,
  onPhoneChange
}) => (
  <>
    <FioInput value={fio} onChange={onFioChange} />
    <PhoneInput value={phone} onChange={onPhoneChange} />
  </>
);

export default UserDataInputs;
